export default __webpack_public_path__ + "static/COVID-19_Guidelines_Banner-min-d78e8e24bf1f4488d5f8e1757fd0c99a.jpg";